import type { FileResult } from 'components/types';
import { Button } from 'design-system/base';
import { getDocumentAsync } from 'expo-document-picker';
import { readFiles } from 'helpers/file';
import type React from 'react';
import { useCallback } from 'react';
import { strings } from 'strings';

interface UploadButtonProps {
  onSelect: (files: FileResult[]) => void;
  allowedExtensions?: string | string[];
  allowMultipleFiles?: boolean;
}

export const UploadButton: React.FC<UploadButtonProps> = ({
  onSelect,
  allowedExtensions = undefined,
  allowMultipleFiles = true,
}) => {
  const onPress = useCallback(async () => {
    const document = await getDocumentAsync({
      multiple: allowMultipleFiles,
      type: allowedExtensions,
    });

    if (!document.canceled) {
      const files = await readFiles(document);

      onSelect(files);
    }
  }, [onSelect, allowedExtensions, allowMultipleFiles]);

  return (
    <Button onPress={onPress} variant="outlined" text={strings.ChooseFile} />
  );
};
